<app-features-container
  header="{{ '+INSTALLATIONS.INSTALLATION.BATTERY_OVERALL_TITLE' | translate }}"
  class="container"
  *ngrxLet="devicesStore.shouldUseConsolidatedFeature$ as shouldUseConsolidatedFeature"
>
  <!-- ess.power.consolidated -->
  <app-feature-tile
    *ngIf="shouldUseConsolidatedFeature && powerConsolidated$ | async | ready as feature"
    feature
    data-at-gateway-serial
    [label]="'+INSTALLATIONS.INSTALLATION.VITOCHARGE.BATTERY.POWER' | translate"
    value="{{ feature | value2: featurePropertyKey.total | absoluteValue }} {{
      feature | unit: featurePropertyKey.total
    }}"
  ></app-feature-tile>
  <!-- ess.power -->
  <app-feature-tile
    *ngIf="!shouldUseConsolidatedFeature && power$ | async | ready as feature"
    feature
    data-at-gateway-serial
    [label]="'+INSTALLATIONS.INSTALLATION.VITOCHARGE.BATTERY.POWER' | translate"
    value="{{ feature | value2: featurePropertyKey.activePower | absoluteValue }} {{
      feature | unit: featurePropertyKey.activePower
    }}"
  ></app-feature-tile>

  <!-- ess.stateOfCharge.consolidated -->
  <app-feature-tile
    *ngIf="shouldUseConsolidatedFeature && stateOfChargeConsolidated$ | async | ready as feature"
    feature
    data-at-gateway-serial
    [label]="'+INSTALLATIONS.INSTALLATION.VITOCHARGE.BATTERY.STATE_OF_CHARGE' | translate"
    value="{{ feature | value2: featurePropertyKey.total }} {{
      feature | unit: featurePropertyKey.total
    }}"
  ></app-feature-tile>
  <!-- ess.stateOfCharge -->
  <app-feature-tile
    *ngIf="!shouldUseConsolidatedFeature && stateOfCharge$ | async | ready as feature"
    feature
    data-at-gateway-serial
    [label]="'+INSTALLATIONS.INSTALLATION.VITOCHARGE.BATTERY.STATE_OF_CHARGE' | translate"
    value="{{ feature | value2: featurePropertyKey.total }} {{
      feature | unit: featurePropertyKey.total
    }}"
  ></app-feature-tile>

  <!-- ess.battery.capacityNominal.consolidated -->
  <app-feature-tile
    *ngIf="shouldUseConsolidatedFeature && capacityConsolidated$ | async | ready as feature"
    feature
    data-at-battery-capacity
    [label]="'+INSTALLATIONS.INSTALLATION.VITOCHARGE.BATTERY.TOTAL_CAPACITY' | translate"
    value="{{ feature | value2: featurePropertyKey.total }} {{
      feature | unit: featurePropertyKey.total
    }}"
  ></app-feature-tile>
  <!-- ess.battery.capacityNominal -->
  <app-feature-tile
    *ngIf="!shouldUseConsolidatedFeature && capacity$ | async | ready as feature"
    feature
    data-at-battery-capacity
    [label]="'+INSTALLATIONS.INSTALLATION.VITOCHARGE.BATTERY.TOTAL_CAPACITY' | translate"
    value="{{ feature | value2: featurePropertyKey.total }} {{
      feature | unit: featurePropertyKey.total
    }}"
  ></app-feature-tile>
</app-features-container>
